import {queryDatabaseData} from "./DatabaseSelect";
import {querySoftwareData} from "./SoftwareSelect";

export const getSoftwareLoaders = (baseArticleType = null) => {

    let softwareLoaders = []

    switch (baseArticleType) {

        case 'server':
            softwareLoaders.push(queryDatabaseData())

        //eslint-disable-next-line
        case 'vserver':
        case 'hosting':
        case 'shared':
        default:

            softwareLoaders.push(querySoftwareData())
            break

    }

    return softwareLoaders

}



/** WEBPACK FOOTER **
 ** ./src/actions/AppInit.SoftwareLoaders.js
 **/